export const buildProvenance = { "commitHash": "da6b9a720aa8c1b9bf1b2636cd69218fa9617539", "branchName": "refs/heads/release/2025.3", "buildDate": "2025-09-23T02:54:41.543Z", "version": "2025.3.14311" };
